import { createContextualCan } from '@casl/react';

import type { AppAbility } from '~/shared/auth/permissions';
import { AbilityContext } from '~/shared/contexts';

export const Can = createContextualCan<AppAbility>(AbilityContext.Consumer);
